package com.dotdrives.web.pages.forms

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

internal val FormDonorPreviewStyles = FC<Props> {
    style { +"""
.v2-logo-upload { display:flex; flex-direction:column; gap:6px; min-width:0; }
.v2-logo-heading { font-size:12px; font-weight:800; }
.v2-logo-card { display:flex; align-items:center; gap:10px; border:1px solid #D9DEE3; border-radius:10px; padding:10px; }
.v2-logo-thumbnail { width:40px; height:40px; flex:none; border-radius:8px; background:#222D32; color:#F26223; display:grid; place-items:center; font-size:28px; }
.v2-logo-thumbnail img { width:36px; height:36px; object-fit:contain; }
.v2-logo-info { display:flex; flex-direction:column; gap:4px; min-width:0; flex:1; }
.v2-logo-info span:first-child { overflow:hidden; white-space:nowrap; text-overflow:ellipsis; font-size:12px; font-weight:800; }
.v2-logo-info span:last-child,.v2-logo-help { font-size:11px; color:#5A6870; line-height:1.5; }
.v2-logo-choose { position:relative; border:1px solid #D9DEE3; border-radius:99px; padding:7px 10px; font-size:12px; font-weight:800; white-space:nowrap; cursor:pointer; }
.v2-logo-choose input[type=file] { position:absolute; width:1px; height:1px; opacity:0; overflow:hidden; padding:0; border:0; }
.v2-logo-choose:focus-within { outline:2px solid #F26223; outline-offset:2px; }
.v2-logo-choose.disabled { opacity:.55; cursor:default; }
.v2-donor-preview { min-width:0; width:100%; display:flex; flex-direction:column; background:#EFF1F4; }
.v2-preview-toolbar { display:flex; align-items:center; flex-wrap:wrap; gap:12px; padding:12px 20px; }
.v2-device-switch { display:flex; padding:3px; border:1px solid #E4E8EC; border-radius:99px; background:#fff; }
.v2-device-switch button { border:0; background:transparent; color:#5A6870; font:800 12.5px 'Nunito Sans',sans-serif; padding:7px 14px; border-radius:99px; cursor:pointer; }
.v2-device-switch button.selected { background:#222D32; color:#fff; }
.v2-preview-hint { font-size:12px; color:#5A6870; }
.v2-preview-stage { margin:4px 24px 24px; min-width:0; display:flex; justify-content:center; align-items:flex-start; }
.v2-preview-sizing { flex:none; }
.v2-preview-frame { background:#FFFDFA; box-shadow:0 24px 64px #222D3226; overflow:hidden; }
.v2-preview-mobile { width:390px; border-radius:28px; }
.v2-preview-desktop { width:1100px; border-radius:16px; }
.v2-preview-jumps { display:flex; justify-content:center; gap:12px; background:#fff; padding:8px; }
.v2-preview-jumps button { border:0; background:transparent; padding:4px; font-size:11px; font-weight:800; color:#5A6870; cursor:pointer; }
.v2-preview-jumps button:hover { color:#A64016; text-decoration:underline; }
.v2-preview-note { font-size:12px; color:#5A6870; padding:0 24px 18px; line-height:1.5; margin:0; }
.v2-preview-frame .give-layout { min-height:0; background:#FFFDFA; }
.v2-preview-frame .give-brand { margin-bottom:28px; font-size:18px; }
.v2-preview-frame .give-story h1 { font-size:34px; line-height:1.15; letter-spacing:0; margin:0 0 16px; }
.v2-preview-frame .give-story-copy { font-size:15px; line-height:1.7; }
.v2-preview-frame .give-story-foot { padding-top:24px; }
.v2-preview-frame .give-intro { display:none; }
.v2-preview-frame .give-notice { font-size:11px; padding:9px 12px; margin:12px 0; }
.v2-preview-frame .give-notice p { display:none; }
.v2-preview-frame .give-form h2 { font-size:22px; }
.v2-preview-frame .give-form fieldset { margin:16px 0; }
.v2-preview-frame .give-form legend { font-size:13px; margin-bottom:10px; }
.v2-preview-frame .give-amounts { gap:10px; }
.v2-preview-frame .give-amount { min-height:62px; border-radius:12px; padding:10px; }
.v2-preview-frame .give-amount strong { font:800 18px 'Nunito Sans',sans-serif; }
.v2-preview-frame .give-field { margin:8px 0; font-size:12px; }
.v2-preview-frame .give-field input,.v2-preview-frame .give-field select,.v2-preview-frame .give-field textarea { font-size:14px; border-radius:12px; }
.v2-preview-desktop .give-layout { grid-template-columns:minmax(0,630px) 470px; height:760px; display:grid; }
.v2-preview-desktop .give-story-text.collapsible:not(.expanded) { display:block; overflow:visible; -webkit-line-clamp:unset; }
.v2-preview-desktop .give-story-expand { display:none; }
.v2-preview-desktop .give-story { padding:48px 56px; overflow:auto; }
.v2-preview-desktop .give-panel { padding:40px 44px; overflow:auto; }
.v2-preview-mobile .give-layout { display:block; }
.v2-preview-mobile .give-story { padding:18px 20px 22px; border-top-width:5px; }
.v2-preview-mobile .give-brand { font-size:14px; gap:9px; margin-bottom:14px; }
.v2-preview-mobile .give-logo { width:28px; height:28px; border-radius:8px; }
.v2-preview-mobile .give-story h1 { font-size:21px; line-height:1.2; margin-bottom:10px; }
.v2-preview-mobile .give-eyebrow,.v2-preview-mobile .give-story-foot { display:none; }
.v2-preview-mobile .give-story-copy { font-size:13px; line-height:1.55; margin:0; }
.v2-preview-mobile .give-story-text.collapsible:not(.expanded) { display:-webkit-box; -webkit-line-clamp:5; -webkit-box-orient:vertical; overflow:hidden; }
.v2-preview-mobile .give-story-expand { display:inline-block; }
.v2-preview-mobile .give-panel { padding:18px 20px 22px; }
.v2-preview-mobile .give-panel h2 { display:none; }
.v2-preview-mobile .give-contact-grid { grid-template-columns:1fr; }
.v2-preview-mobile .give-form button { font-size:13px; }
.v2-preview-mobile .give-total strong { font-size:20px; }
.v2-preview-mobile .give-panel footer { margin-top:16px; }
.v2-preview-frame button:focus-visible { outline:2px solid #F26223; outline-offset:2px; }
@media(max-width:600px) { .v2-preview-stage { margin:4px 12px 20px; } .v2-preview-toolbar { padding:12px; } }
""" }
}
